import * as React from 'react'
import * as Yup from 'yup'
import * as rt from '../../config/routeType'
import { Formik, Form } from 'formik'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import { activated, verificated } from '../../redux/slices/Auth/login'
import { show as showDrawerRight } from '../../redux/slices/Drawer/drawerRight'
import { Grid, Box, SvgIcon, Link, Alert } from '@mui/material'
import { InputAdornment, IconButton, Button } from '@mui/material'
import { Lock, AccountCircle, Visibility, VisibilityOff } from '@mui/icons-material'
import { ReactComponent as LoginImage } from '../../assets/images/Login.svg'
import { isUserVerify, login } from '../../services'

import { INITIAL_FORM_STATE } from '../../utils/formikUpdate'
import { schema } from '../../utils/schemaValidation'

import Textfield from '../FormsUI/Textfield'

const BUTTON_COLOR = 'var(--color-green-light)'
const TEXT_BUTTON_COLOR = '#EDEEFF'
const COLORLINKSTEXT = 'rgb(0 0 0 / 50%)'
const FONTFAMILYTYPE = 'var(--font-family)'

const styleSvg = { width: 300, height: 220 }

const ButtonCustom = styled(Button)({
  height: '2em',
  backgroundColor: BUTTON_COLOR,
  textTransform: 'capitalize',
  fontFamily: 'Avenir Next',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '22px',
  color: TEXT_BUTTON_COLOR,
  fontSize: '16px',
  '&:hover': {
    backgroundColor: '#0fa73d',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: BUTTON_COLOR,
    borderColor: BUTTON_COLOR,
  },
})

const styleLinkText = {
  color: COLORLINKSTEXT,
  fontFamily: FONTFAMILYTYPE,
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '15px',
  lineHeight: '12px',
  textDecoration: 'none',
  '&:hover': {
    color: 'var(--color-green-light)',
    textDecoration: 'underline',
    fontWeight: 600,
    cursor: 'pointer',
  },
}
const centerModalStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}

const boxStyle = {
  width: 405,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: '25px',
  textAlign: 'center',
  borderRadius: '14px',
}

const Login = React.forwardRef(({ modal, icon = true }, ref) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [showPassword, setShowPassword] = React.useState(false)
  const [alert, setAlert] = React.useState(null)
  const _loginState = useSelector(state => state.login)

  const handleClickShowPassword = () => setShowPassword(!showPassword)
  const handleMouseDownPassword = event => event.preventDefault()
  const handleForgotPassword = () => {
    dispatch(showDrawerRight(false))
    dispatch(activated(false))
    navigate(rt.FORGOT_PASSWORD)
  }
  const handleRegisterUser = () => {
    dispatch(showDrawerRight(false))
    dispatch(activated(false))
    navigate(rt.REGISTER_USER)
  }

  const styleB = modal ? { ...boxStyle, ...centerModalStyles } : boxStyle

  const handleClickLogin = async ({ email, password_login: password }) => {
    const response = await login({ email, password })

    if (!response.error) {
      if (response.accountLogin === 'rejected')
        setAlert({
          type: 'warning',
          message:
            'Verifique su correo electrónico o contraseña. Credenciales incorrectas.',
        })

      if (response.accountLogin === 'pending')
        setAlert({ type: 'info', message: response.message })

      if (response.accountLogin === 'approved') {
        dispatch(activated(!_loginState.visible))
        window.localStorage.setItem('arbolQR_Token', response.token)
        isUserVerify(`Bearer ${response.token}`)
          .then(userLocal => dispatch(verificated(userLocal)))
          .catch(err => console.log('err :>> ', err))
      }
      return
    }
    setAlert({ type: 'error', message: response.message })
  }

  const FORM_VALIDATION = Yup.object().shape({
    ...schema.EMAIL,
    ...schema.PASSWORD_LOGIN,
  })

  return (
    <Box sx={styleB} ref={ref}>
      {icon && (
        <Box>
          <SvgIcon sx={styleSvg} component={LoginImage} inheritViewBox />
        </Box>
      )}
      <Box>
        <Formik
          initialValues={{ ...INITIAL_FORM_STATE }}
          validationSchema={FORM_VALIDATION}
          onSubmit={async values => await handleClickLogin(values)}>
          <Form>
            <Grid container spacing={2} sx={{ pt: 0, width: '100%', ml: 0 }}>
              <Grid item xs={12} style={{ paddingLeft: 0 }}>
                <Textfield
                  name="email"
                  label="Ingrese su correo electrónico"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle />
                      </InputAdornment>
                    ),
                  }}
                  placeholder="user@example.com"
                />
              </Grid>
              <Grid item xs={12} style={{ paddingLeft: 0 }}>
                <Textfield
                  name="password_login"
                  label="Ingrese su contraseña"
                  type={showPassword ? 'text' : 'password'}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end">
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  placeholder="password"
                />
              </Grid>
              {alert && (
                <Grid item xs={12} style={{ paddingLeft: 0 }}>
                  <Alert severity={alert.type}>{alert.message}</Alert>
                </Grid>
              )}
              <Grid item xs={12} style={{ paddingLeft: 0 }}>
                <ButtonCustom variant="contained" fullWidth type="submit">
                  Iniciar Sesión
                </ButtonCustom>
              </Grid>
              <Grid item xs={8} style={{ paddingLeft: 0, textAlign: 'start' }}>
                <Link onClick={handleForgotPassword} sx={styleLinkText}>
                  ¿Olvidaste tu contraseña?
                </Link>
              </Grid>
              <Grid item xs={4} style={{ paddingLeft: 0, textAlign: 'end' }}>
                <Link onClick={handleRegisterUser} sx={styleLinkText}>
                  Crear cuenta
                </Link>
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </Box>
    </Box>
  )
})

export default Login
